import App from "@/App";
import { AppErrorBoundary } from "@/components/AppErrorBoundary";
import { AuthProvider } from "@/context/AuthContext";

export function AppRoot() {
  return (
    <AppErrorBoundary>
      <AuthProvider>
        <App />
      </AuthProvider>
    </AppErrorBoundary>
  );
}
